<template>
    <div class="morning-check-device">
        <!-- 搜索筛选区域 -->
        <el-card class="search-card">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item label="检测日期">
                    <!-- 修复1：移除错误的 default-value，添加空值兼容 -->
                    <el-date-picker v-model="searchForm.checkTime" type="date" placeholder="选择检测日期"
                        value-format="yyyy-MM-dd" :disabled="false">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="晨检结果">
                    <el-select v-model="searchForm.health" placeholder="请选择" clearable>
                        <el-option label="全部" value=""></el-option>
                        <el-option label="合格" value="0"></el-option>
                        <el-option label="不合格" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button @click="resetSearch" icon="el-icon-refresh">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 设备列表 -->
        <el-card class="device-table">
            <el-table :data="pagedDeviceList" border style="width: 100% ;height: 68vh;overflow: auto;"
                @row-click="handleRowClick" ref="deviceTable">
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="realName" label="名字" align="center"></el-table-column>
                <el-table-column prop="foreheadTemp" label="温度(℃)" align="center"></el-table-column>
                <el-table-column prop="normalTemperatureRange" label="正常温度范围(℃)" align="center"></el-table-column>
                <el-table-column prop="checkTime" label="最近检测时间" align="center"></el-table-column>
                <el-table-column prop="handCheckResult" label="手部检测" align="center">
                    <template slot-scope="scope">
                        <el-tag>
                            {{

                                scope.row.handCheckResult == '' ? '正常' :
                                    scope.row.handCheckResult
                            }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="abnormalTemp" label="温度是否异样" align="center" width="130">
                    <template slot-scope="scope">
                        <el-tag
                            :type="scope.row.abnormalTemp == 1 ? 'danger' : (scope.row.abnormalTemp == 0 ? 'success' : 'info')">
                            {{
                                scope.row.abnormalTemp == 1 ? '异常' :
                                    scope.row.abnormalTemp == 0 ? '正常' :
                                        '未检测'
                            }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="healthAskResult" label="健康询问" width="180" align="center">
                    <template slot-scope="scope">
                        <el-tag>
                            {{

                                scope.row.healthAskResult == '' ? '正常' :
                                    scope.row.healthAskResult
                            }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="health" label="晨检结果" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.health == 1 ? 'danger' : (scope.row.health == 0 ? 'success' : 'info')">
                            {{
                                scope.row.health == 1 ? '不合格' :
                                    scope.row.health == 0 ? '合格' :
                                        '未检测'
                            }}
                        </el-tag>
                    </template>
                </el-table-column>

                <!-- 人脸图片列 -->
                <el-table-column prop="faceFileUrl" label="人脸图片" width="180" align="center">
                    <template slot-scope="scope">
                        <div class="image-container">
                            <img v-if="scope.row.faceFileUrl" :src="scope.row.faceFileUrl" alt="人脸图片"
                                class="preview-image" @click="previewImage(scope.row.faceFileUrl, '人脸图片')"
                                onerror="this.onerror=null; this.src='https://cdn.jsdelivr.net/gh/ant-design/ant-design-icons@4.0.0/packages/icons-svg/svg/outline/picture-outline.svg'">
                            <div v-else class="no-image">
                                <i class="el-icon-picture-outline"></i>
                                <span>暂无图片</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <!-- 手心图片列 -->
                <el-table-column prop="palmFileUrl" label="手心图片" width="180" align="center">
                    <template slot-scope="scope">
                        <div class="image-container">
                            <img v-if="scope.row.palmFileUrl" :src="scope.row.palmFileUrl" alt="手心图片"
                                class="preview-image" @click="previewImage(scope.row.palmFileUrl, '手心图片')"
                                onerror="this.onerror=null; this.src='https://cdn.jsdelivr.net/gh/ant-design/ant-design-icons@4.0.0/packages/icons-svg/svg/outline/picture-outline.svg'">
                            <div v-else class="no-image">
                                <i class="el-icon-picture-outline"></i>
                                <span>暂无图片</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <!-- 手背图片列 -->
                <el-table-column prop="backOfHandFileUrl" label="手背图片" width="180" align="center">
                    <template slot-scope="scope">
                        <div class="image-container">
                            <img v-if="scope.row.backOfHandFileUrl" :src="scope.row.backOfHandFileUrl" alt="手背图片"
                                class="preview-image" @click="previewImage(scope.row.backOfHandFileUrl, '手背图片')"
                                onerror="this.onerror=null; this.src='https://cdn.jsdelivr.net/gh/ant-design/ant-design-icons@4.0.0/packages/icons-svg/svg/outline/picture-outline.svg'">
                            <div v-else class="no-image">
                                <i class="el-icon-picture-outline"></i>
                                <span>暂无图片</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                </el-pagination>
            </div>
        </el-card>

        <!-- 图片预览弹窗 -->
        <el-dialog :title="previewTitle" :visible.sync="previewVisible" width="80%" append-to-body
            class="image-preview-dialog">
            <div class="preview-content">
                <img :src="previewImageUrl" :alt="previewTitle" class="preview-img">
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="previewVisible = false">关闭</el-button>
                <el-button type="primary" @click="downloadImage">下载图片</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getCheckData } from "@/api/morningCheck";

export default {
    data() {
        return {
            // 搜索表单
            searchForm: {
                deviceCode: '',
                status: '',
                checkTime: '', // 初始化为空字符串，避免undefined
                health: ''
            },

            // 设备列表数据
            rawDeviceList: [],
            deviceList: [],
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,

            // 弹窗控制
            recordVisible: false,
            controlVisible: false,
            currentDevice: null,

            // 检测记录
            checkRecords: [],

            // 控制表单
            controlForm: {
                deviceName: '',
                status: '',
                command: 'restart',
                remark: ''
            },

            // 图片预览相关
            previewVisible: false,
            previewImageUrl: '',
            previewTitle: ''
        }
    },
    computed: {
        pagedDeviceList() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = start + this.pageSize;
            return this.deviceList.slice(start, end);
        }
    },
    mounted() {
        this.loadDeviceList();
    },
    methods: {
        // 加载设备列表
        loadDeviceList() {
            getCheckData({ userId: localStorage.getItem('userId') }).then(response => {
                const mockData = response.data || []; // 兼容接口返回空的情况
                console.log(mockData);

                this.rawDeviceList = mockData;
                this.deviceList = [...this.rawDeviceList];
                this.totalCount = this.deviceList.length;
            }).catch(error => {
                console.error('加载数据失败:', error);
                this.rawDeviceList = [];
                this.deviceList = [];
                this.totalCount = 0;
            });
        },

        // 搜索设备（修复日期筛选逻辑）
        handleSearch() {
            this.currentPage = 1;
            let filteredData = [...this.rawDeviceList];

            // 修复2：兼容checkTime为空/undefined的情况
            if (this.searchForm.checkTime && this.searchForm.checkTime.trim()) {
                const targetDate = this.searchForm.checkTime.trim();
                filteredData = filteredData.filter(item => {
                    // 先判断item.checkTime是否存在，再进行匹配
                    if (!item.checkTime) return false;
                    // 兼容时间格式：2025-11-27 12:00:00 或 2025-11-27
                    return item.checkTime.startsWith(targetDate);
                });
            }

            // 晨检结果筛选
            if (this.searchForm.health !== '') {
                const healthValue = Number(this.searchForm.health);
                filteredData = filteredData.filter(item =>
                    item.health === healthValue
                );
            }

            this.deviceList = filteredData;
            this.totalCount = filteredData.length;
        },

        // 重置搜索
        resetSearch() {
            this.searchForm = {
                deviceCode: '',
                status: '',
                checkTime: '',
                health: ''
            };
            this.currentPage = 1;
            this.deviceList = [...this.rawDeviceList];
            this.totalCount = this.deviceList.length;
        },

        // 分页处理
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        },

        // 行点击事件
        handleRowClick(row) {
            if (this.$refs.deviceTable) {
                this.$refs.deviceTable.toggleRowSelection(row);
            }
        },

        // 预览图片
        previewImage(url, title) {
            if (!url) return; // 避免空链接
            this.previewImageUrl = url;
            this.previewTitle = title;
            this.previewVisible = true;
        },

        // 下载图片
        downloadImage() {
            if (!this.previewImageUrl) {
                this.$message.warning('暂无图片可下载');
                return;
            }

            try {
                const link = document.createElement('a');
                link.href = this.previewImageUrl;
                link.download = `${this.previewTitle}_${new Date().getTime()}.png`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.$message.success('图片下载成功');
            } catch (error) {
                console.error('下载图片失败:', error);
                this.$message.error('图片下载失败，请重试');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.morning-check-device {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: 100vh;
}

.search-card {
    margin-bottom: 20px;
}

.search-form {
    margin-top: 10px;
}

.device-table {
    .pagination-container {
        margin-top: 15px;
        text-align: right;
    }
}

// 图片容器样式
.image-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 80px;
    border: 1px dashed #e4e7ed;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;


    &:hover {
        border-color: #409eff;
        background-color: #f8f9fa;
    }

    .preview-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 3px;
    }

    .no-image {
        text-align: center;
        color: #909399;

        i {
            font-size: 24px;
            margin-bottom: 4px;
            display: block;
        }

        span {
            font-size: 12px;
        }
    }
}

// 图片预览弹窗样式
::v-deep .image-preview-dialog {
    .preview-content {
        text-align: center;
        padding: 10px 0;

        .preview-img {
            max-width: 100%;
            max-height: 70vh;
            object-fit: contain;
        }
    }

    .dialog-footer {
        text-align: center;
    }
}

::v-deep .el-dialog__body {
    max-height: 80vh;
    overflow-y: auto;
    padding: 20px;
}

// 修复表格行高一致
::v-deep .el-table__row {
    height: 100px !important;
}

::v-deep .el-table__cell {
    padding: 10px 0;
    text-align: center;
}
</style>
